<template>
    <div>
        <div class="w-full flex flex-col lg:justify-between py-4 border-b border-gray-300">
            {{ $t('OneSignal Testing') }}
            <p class="mt-2">
                {{ $t('Testing for OneSignal API') }}
            </p>
        </div>

        <div class="my-8">
            <FormButton class="mt-6 w-auto" @click="update()" styling="primary" :value="$t('Update OneSignal Notification Channels')"> </FormButton>
            <br />

            <!-- Display the UserId -->
            <p>{{ $t('User ID') }}: {{ user?.id }}</p>
            <div class="flex flex-row gap-6 items-center">
                <SingleToggle :active="neueAnalysen" @update:active="neueAnalysen = !neueAnalysen" backgroundColor="#031837" backgroundGradient="#031837" />
                <p>
                    {{ $t('Neue Analysen') }}
                </p>
            </div>

            <div class="flex flex-row gap-6 items-center">
                <SingleToggle :active="videoAnalysen" @update:active="videoAnalysen = !videoAnalysen" backgroundColor="#031837" backgroundGradient="#031837" />
                <p>
                    {{ $t('Video-Analysen') }}
                </p>
            </div>

            <div class="flex flex-row gap-6 items-center">
                <SingleToggle :active="kurznachrichten" @update:active="kurznachrichten = !kurznachrichten" backgroundColor="#031837" backgroundGradient="#031837" />
                <p>
                    {{ $t('contenstream_category_short') }}
                </p>
            </div>

            <div class="flex flex-row gap-6 items-center">
                <SingleToggle :active="zielzonen" @update:active="zielzonen = !zielzonen" backgroundColor="#031837" backgroundGradient="#031837" />
                <p>
                    {{ $t('Zielzonen') }}
                </p>
            </div>

            <div class="flex flex-row gap-6 items-center">
                <SingleToggle :active="hkcmTrades" @update:active="hkcmTrades = !hkcmTrades" backgroundColor="#031837" backgroundGradient="#031837" />
                <p>
                    {{ $t('HkcmTrades') }}
                </p>
            </div>

            <div class="flex flex-row gap-6 items-center">
                <SingleToggle :active="hkcmNews" @update:active="hkcmNews = !hkcmNews" backgroundColor="#031837" backgroundGradient="#031837" />
                <p>
                    {{ $t('HkcmNews') }}
                </p>
            </div>

            <br />
            <h4 v-if="apiResponse">API-Response (JSON optimized):</h4>
            <pre>{{ apiResponse }}</pre>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import i18next from 'i18next';

export default {
    data: () => ({
        allNotifications: true,
        apiResponse: null,
        neueAnalysen: true,
        videoAnalysen: true,
        kurznachrichten: true,
        zielzonen: true,
        hkcmTrades: true,
        hkcmNews: true
    }),
    mounted() {},
    computed: {
        ...mapGetters('user', {
            user: 'get'
        }),
        ...mapGetters('abonnements', {
            abonnements: 'get'
        }),
        ...mapGetters('onesignal', {
            onesignal: 'update'
        })
    },
    methods: {
        update() {
            console.log('update');
            let promisses = [];

            promisses.push(this.updateUser());
            promisses.push(this.getUserTags());

            Promise.all(promisses);
        },
        getUserTags() {},
        updateUser() {
            // create a new array with the selected tags without keys, based on the toggles
            let toggleTags = [];
            if (this.neueAnalysen) toggleTags.push('neue-analysen');
            if (this.videoAnalysen) toggleTags.push('video-analysen');
            if (this.kurznachrichten) toggleTags.push('kurznachrichten');
            if (this.zielzonen) toggleTags.push('zielzonen');
            if (this.hkcmTrades) toggleTags.push('hkcm-trades');
            if (this.hkcmNews) toggleTags.push('hkcm-news');

            console.log('toggleTags:', toggleTags);
            return this.$store
                .dispatch('apitest/update', {
                    user_id: this.user.id,
                    tags: toggleTags
                })
                .then((response) => {
                    this.apiResponse = response;
                    console.log('apitest response:', response);
                    this.$toast.success(i18next.t('msg_api_calling_success'));
                })
                .catch((error) => {
                    this.apiResponse = error.response.data ?? error;
                    console.error('apitest error:', error);
                    this.$toast.error(i18next.t('msg_api_calling_error'));
                });
        }
    }
};
</script>
